module.exports = __webpack_public_path__ + "img/logo.2a80a592.png";